// tslint:disable
export enum CampaignOptType {
    /**
     * @description UNKNOWN
     */
    UNKN = 10001,
    /**
     * @description OPT IN
     */
    OPTI = 10002,
    /**
     * @description OPT OUT
     */
    OPTO = 10003,
}
